"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyFrom = void 0;
const isEnumerable_1 = require("../isEnumerable");
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyFrom(factory, src) {
    if ((0, isEnumerable_1.isEnumerable)(src)) {
        return src;
    }
    if (Array.isArray(src)) {
        return factory.createArrayEnumerable((0, utilityFunctions_1.getIterableGenerator)(src), src);
    }
    if (typeof src[Symbol.iterator] === 'function') {
        return factory.createBasicEnumerable((0, utilityFunctions_1.getIterableGenerator)(src));
    }
    if (typeof src === 'object') {
        const generator = function* () {
            for (const entry of Object.entries(src)) {
                yield entry;
            }
        };
        return factory.createBasicEnumerable(generator);
    }
    throw new Error('Cannot create Enumerable from src.');
}
exports.applyFrom = applyFrom;
//# sourceMappingURL=applyFrom.js.map